import { connect } from 'react-redux'
import WorkOrdersDetails from '../../components/work-orders/work-orders-details'
import { fetchWorkOrder, downloadCSV } from '../../actions/work-orders'
import { loadServicingsForWorkOrder } from '../../actions/servicings'
import { fetchUnreadMessagesForWorkOrder } from '../../actions/messages'
import { searchAvailableAreasByWorkOrder } from '../../actions/areas'
import at from 'lodash/at'
import get from 'lodash/get'
import { getWorkOrderById } from '../../selectors/work-order-selectors'
import { push } from 'react-router-redux'

const mapStateToProps = (state, props) => {
  const workOrder = getWorkOrderById(state, props)

  if (workOrder) {
    const location = state.locations[workOrder.location]
    const technicians = at(state.users, workOrder.technicians)

    const pagination = get(state, `pagination.servicingsByWorkOrder.${props.params.workOrderId}-unfinished`, {})
    const urlPath = props.location

    return {
      ...workOrder,
      services: state.services,
      servicingIds: pagination.ids || [],
      hasNextPage: pagination.nextPageUrl,
      technicians,
      urlPath,
      location
    }
  } else {
    return {
      loading: true
    }
  }
}

const mapDispatchToProps = (dispatch, props) => {
  const workOrderId = props.params.workOrderId

  dispatch(searchAvailableAreasByWorkOrder(workOrderId))

  dispatch(fetchWorkOrder(workOrderId)) // this might respond with a 404
    .then(
      ({meta : {status = null} = {}}) => {
        if (status === 404) {
          dispatch(push('/work-orders'))
        } else {
          dispatch(loadServicingsForWorkOrder(workOrderId, 'unfinished'))
          dispatch(fetchUnreadMessagesForWorkOrder(workOrderId))
        }
      })

  return {
    csvDownload () {
      dispatch(downloadCSV(workOrderId))
    },

    onLoadNextPage () {
      dispatch(loadServicingsForWorkOrder(workOrderId, 'unfinished', true))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrdersDetails)



// WEBPACK FOOTER //
// ./src/containers/work-orders/work-orders-details-container.js